"use strict";

// Only these asset types have their online inspections gated - they're the ones that gained
// inspection UI entry points in this rollout. Manhole (and every other hard asset type) already
// had them and is unaffected. Offline inspections are gated for every hard asset type.
const GATED_ASSET_TYPES = ["pipe", "culvert", "openChannel", "liftStation", "cleanout"];
const FEATURE_FLAG_KEY = "muni-hard-asset-inspections";

const HardAssetInspectionGate = function () {
  var isEnabledForAssetType = function (assetType) {
    if (!GATED_ASSET_TYPES.includes(assetType)) {
      return true;
    }

    return FeatureFlag.enabled(FEATURE_FLAG_KEY);
  };

  // Also gates reading the offline cache, so turning the flag off stops using data that was
  // only downloaded while it was on.
  var isOfflineEnabledForAssetType = function (assetType) {
    // Required here because InspectableAssetCache pulls in map modules that need Leaflet loaded,
    // and this gate is imported by modules that load before Leaflet (e.g. nunjucksFunctions).
    const InspectableAssetCache = require("../offline/inspectableAssetCache");

    return (
      FeatureFlag.enabled(FEATURE_FLAG_KEY) && InspectableAssetCache.hasCacheForAssetType(assetType)
    );
  };

  return {
    isEnabledForAssetType,
    isOfflineEnabledForAssetType,
  };
};

module.exports = HardAssetInspectionGate();

const FeatureFlag = require("../settings/featureFlag");
